<template>
  <v-row no-gutters class="pa-8">
    <v-col cols="12">
      <div class="text-h6">Edit Asset Details</div>
      <div class="primaryGrey--text">Asset ID : {{ asset_model.DeviceID }}</div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row class="py-6">
          <v-col cols="6">
            <v-text-field
              dense
              color="primaryDark"
              v-model="asset_model.DeviceName"
              label="Transformer Name"
              :counter="50"
              :rules="maxRule(50, true)"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.AssetID"
              label="Asset ID"
              :counter="50"
              :rules="maxRule(50, false)"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.SerialNumber"
              label="Transformer No."
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.PowerRating"
              label="Transformer Size (kVA)"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.CurrentLat"
              :rules="numberRule([-90, 90], true)"
              required
              label="Latitude"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.CurrentLng"
              :rules="numberRule([-180, 180], true)"
              required
              label="Longitude"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.DeviceType"
              label="Device Type"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.DeviceVoltage"
              :rules="numberRule([0, 500], false)"
              label="Device Voltage"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.ConnectedMPRNs"
              :rules="numberRule([0, 500], false)"
              label="Connected MPRNs"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.Comment"
              label="Comments"
              :rules="maxRule(500, false)"
              :counter="500"
              append-outer-icon="mdi-comment"
            ></v-text-field>
          </v-col>
          <v-col :cols="show_installation_date ? 2 : 4">
            <v-select
              dense
              color="primaryDark"
              v-model="asset_model.InstallationStatus"
              :items="page_content.InstallationStatus"
              label="Installation Status"
            ></v-select>
          </v-col>
          <v-col cols="2" v-if="show_installation_date">
            <v-menu
              v-model="date_picker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  dense
                  class="pa-0"
                  color="primaryDark"
                  :value="$dateFormat(asset_model.InstallationDate)"
                  label="Installation Date"
                  append-outer-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="asset_model.InstallationDate"
                no-title
                @input="date_picker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="2" class="py-0">
            <v-switch
              dense
              flat
              v-model="asset_model.IsCommuterArea"
              inset
              label="Commuter Area"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn dense outlined class="mr-2 bold" @click="$emit('cancel')"
              >Cancel</v-btn
            >
            <v-btn
              dense
              color="primary"
              @click="validate('save', asset_model)"
              class="bold"
              :disabled="!valid"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { content } from "../../config/config.js";

export default {
  name: "EditAssetDetails",
  props: { asset_data: Object },
  watch: {},
  data: function () {
    return {
      show_installation_date: false,
      valid: true,
      page_content: null,
      maxAndRequiredRule: [
        (v) => !!v || "This field is required",
        (v) => (v && v.length <= 50) || "Must be less than 50 characters",
      ],
      requiredRule: [(v) => !!v || "This field is required"],
      date_picker: false,
    };
  },
  created() {
    this.page_content = content;
  },
  mounted() {},
  methods: {
    maxRule: function (characters, isRequired) {
      return isRequired
        ? [
            (v) => !!v || "This field is required",
            (v) =>
              (v && v.length <= characters) ||
              `Must be less than ${characters} characters`,
          ]
        : [
            (v) =>
              !v ||
              (v && v.length <= characters) ||
              `Must be less than ${characters} characters`,
          ];
    },

    numberRule: function (digits, isRequired) {
      if (typeof digits == "number") {
        return isRequired
          ? [
              (v) => !!v || "This field is required",
              (v) => (v && v <= digits) || `Must be less than ${digits}`,
            ]
          : [(v) => !v || (v && v <= digits) || `Must be less than ${digits}`];
      } else {
        return isRequired
          ? [
              (v) => !!v || "This field is required",
              (v) =>
                (v && v <= digits[1] && v >= digits[0]) ||
                `Must be less than ${digits[1]} and greater than ${digits[0]}`,
            ]
          : [
              (v) =>
                !v ||
                (v && v <= digits[1] && v >= digits[0]) ||
                `Must be less than ${digits}`,
            ];
      }
    },
    validate: function (event, obj) {
      if (this.$refs.form.validate()) {
        obj.InstallationDate =
          obj.InstallationStatus &&
          obj.InstallationStatus.toLowerCase() == "installed"
            ? obj.InstallationDate
            : null;
        this.$emit(event, obj);
      }
    },
    update_installation_date: function () {
      if (
        !this.asset_model ||
        !this.asset_model.InstallationStatus ||
        this.asset_model.InstallationStatus != "Installed"
      )
        this.show_installation_date = false;
      else this.show_installation_date = true;
    },
  },
  computed: {
    formattedInstallationDate() {
      return this.$dateFormat(this.asset_model.InstallationDate);
    },
    asset_model: function () {
      if (
        this.asset_data &&
        this.asset_data.item.InstallationStatus &&
        this.asset_data.item.InstallationStatus == "Installed"
      ) {
        this.show_installation_date = true;
      }
      return {
        DeviceName:
          (this.asset_data && this.asset_data.item.DeviceName) || null,
        AssetID: (this.asset_data && this.asset_data.item.AssetID) || "",
        DeviceType:
          (this.asset_data && this.asset_data.item.DeviceType) || null,
        SerialNumber:
          (this.asset_data && this.asset_data.item.SerialNumber) || null,
        PowerRating:
          (this.asset_data && this.asset_data.item.PowerRating) || null,
        CurrentLat:
          (this.asset_data && this.asset_data.item.CurrentLat) || null,
        DeviceID: (this.asset_data && this.asset_data.item.DeviceID) || null,
        CurrentLng:
          (this.asset_data && this.asset_data.item.CurrentLng) || null,
        InstallationDate:
          (this.asset_data && this.asset_data.item.InstallationDate) || null,
        InstallationStatus:
          (this.asset_data && this.asset_data.item.InstallationStatus) || null,
        Comment: (this.asset_data && this.asset_data.item.Comment) || null,
        IsCommuterArea:
          (this.asset_data && this.asset_data.item.IsCommuterArea) || null,
        DeviceVoltage:
          (this.asset_data && this.asset_data.item.DeviceVoltage) || null,
        ConnectedMPRNs:
          (this.asset_data && this.asset_data.item.ConnectedMPRNs) || null,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.opaque {
  opacity: 0.7;
}
</style>
